/*
 * vyraél — Cart Rescue (two-stage), ported from the Verdena build
 * ------------------------------------------------------------------
 * Works with the Dawn <cart-drawer> and Kaching Bundles.
 *
 * How bundles are identified (from the live cart, not from quantity):
 *   Kaching writes a line property  __kaching_bundles = {"main":true,"bid":"<deal bar id>","id":"<group>",...}
 *   main line   -> main:true          (the bundle itself)
 *   gift lines  -> gift:"<id>"        (same group id)
 *   upsell line -> upsell:"<id>"      (same group id, the +1 extra bottle)
 *   bid -> tier mapping comes from the "Cart rescue" section settings.
 *
 * Triggers
 *   A) user closes the drawer (X, overlay, Escape)  -> drawer closes first, then offer
 *   B) user removes the MAIN bundle line            -> removal completes, then offer to restore
 *   Never: empty cart, upsell/gift removal, quantity edits, checkout, unrelated products.
 *
 * Nothing here touches Kaching's buttons, markup or pricing. Benefits are applied
 * ONLY after an explicit accept click.
 */
(function () {
  'use strict';
  if (window.__vyraelRescue) return;            // never bind twice (section re-renders, theme editor)
  window.__vyraelRescue = true;

  var cfgEl = document.getElementById('VyraelRescueConfig');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.enabled) return;

  var log = function () { if (CFG.debug && window.console) console.log.apply(console, ['[vyrael-rescue]'].concat([].slice.call(arguments))); };

  /* ---------------- session state ---------------- */
  var SS_KEY = 'vyrael_rescue_v1';
  var memState = null;
  var session = {
    // frequency "always" (default): offer on every eligible close/removal.
    // frequency "session": at most once per browser session.
    get: function () {
      if (CFG.frequency !== 'session') return null;
      try { return sessionStorage.getItem(SS_KEY); } catch (e) { return memState; }
    },
    set: function (v) { memState = v; try { sessionStorage.setItem(SS_KEY, v); } catch (e) {} }
  };
  if (CFG.debug && /[?&]vd_rescue_reset=1/.test(location.search)) session.set('');

  /* ---------------- order metadata ---------------- */
  var ATTR = {
    guarantee: 'vyrael Guarantee',
    foodmap: 'vyrael Free Guide',
    offer: 'vyrael Cart Offer',
    group: '_vyrael_offer_group',
    code: '_vyrael_offer_code',
    reason: 'vyrael Leave Reason'
  };

  /* ---------------- copy ----------------
     Benefits and escalation per bundle are the approved ones (no new gifts/discounts):
       Buy 1        S1 Lower Cortisol Guide -> S2 guide + 60-day guarantee
       Buy 2 Get 1  S1 60-day guarantee    -> S2 60-day guarantee + $10 off
       Buy 3 Get 3  S1 90-day guarantee    -> S2 90-day guarantee + $15 off
     Headline/support text adapts to the reason picked on the first screen. */
  var REASONS = [
    { id: 'unsure', label: "I'm not sure it'll work for me" },
    { id: 'tried', label: "I've already tried so many things" },
    { id: 'budget', label: "It's outside my budget" }
  ];
  var ASK = { title: "You're leaving already?", support: "What's holding you back from trying Moringa Pure?" };
  var OFFERS = {
    buy1: {
      label: 'Buy 1',
      s1: {
        title: { unsure: "Give Moringa Pure a fair shot. We'll help you start.", tried: "You've tried a lot. Let's make this time easier.", budget: "Let's make your first bottle count.", 'default': "Give Moringa Pure a fair shot. We'll help you start." },
        support: "Before you go, we'd like to give you something useful to make your first month easier.",
        card: { title: 'Your Lower Cortisol Guide', sub: 'Included FREE with your order' },
        cta: 'YES, ADD MY FREE GUIDE', give: { foodmap: true }
      },
      s2: {
        title: "We believe in Moringa Pure. So we're doubling our promise.",
        support: "Keep your free Lower Cortisol Guide. And because we stand behind it, we'll double your money-back guarantee from 30 to 60 days.",
        card: { list: ['Lower Cortisol Guide — FREE', '60-Day Money-Back Guarantee'], note: 'Same bottle. Same price.' },
        cta: "YES, I'LL TAKE BOTH", give: { foodmap: true, days: 60 }
      }
    },
    buy2: {
      label: 'Buy 2 Get 1 FREE',
      s1: {
        title: { unsure: "Not sure it'll work? Let us take the risk.", tried: "You've tried a lot. This time, the risk is ours.", budget: "Let's make it a safer spend.", 'default': 'Wait. Let us take the risk.' },
        support: { unsure: 'Try all 3 bottles with twice as long to decide. Same bottles, same price.', tried: 'Same 3 bottles, same price, and twice as long to see if Moringa Pure is different for you.', budget: 'Same 3 bottles at the same price, with twice as long to decide if it was worth it.', 'default': 'Same 3 bottles. Same price. Twice as long to decide.' },
        card: { title: '60-Day Money-Back Guarantee', sub: 'Doubled from 30 days. Your bundle gifts stay.' },
        cta: 'YES, GIVE ME 60 DAYS', give: { days: 60 }
      },
      s2: {
        title: { budget: "Okay. Let's make it easier on your budget.", 'default': "Okay. Let's make this even easier." },
        support: "Keep the 60-day guarantee, and we'll take another $10 off your order.",
        card: { title: '$10 off your order', price: true, list: ['60-Day Money-Back Guarantee', 'All bundle gifts kept'] },
        cta: "YES, I'LL TAKE THAT DEAL", give: { days: 60, off: 1000, codeKey: 'buy2' }
      }
    },
    buy3: {
      label: 'Buy 3 Get 3 FREE',
      s1: {
        title: { tried: "You've tried a lot. Let us carry the risk.", budget: 'A bigger order should feel safer.', 'default': 'Six bottles is a big decision. We get it.' },
        support: { unsure: "So we'll stand behind it: 90 days to decide, at no extra charge.", tried: 'Same 6 bottles, same price, with 90 days to decide if Moringa Pure deserves a place in your routine.', budget: 'Same 6 bottles, same price, with 90 days to be sure it was worth it.', 'default': "If you're trusting us with an order this size, we should stand behind it." },
        card: { title: '90-Day Money-Back Guarantee', sub: 'Tripled from 30 days. Your bundle gifts stay.' },
        cta: 'YES, GIVE ME 90 DAYS', give: { days: 90 }
      },
      s2: {
        title: { budget: "Alright. Let's take $15 off.", 'default': "Alright. Here's what we can offer." },
        support: "We'll keep your 90-day guarantee and take another $15 off your order.",
        card: { title: '$15 off your order', price: true, list: ['90-Day Money-Back Guarantee', 'All bundle gifts kept'] },
        cta: 'YES, SAVE MY $15', give: { days: 90, off: 1500, codeKey: 'buy3' }
      }
    }
  };
  function pick(v, reason) { return typeof v === 'string' ? v : (v[reason] || v['default']); }
  /* ---------------- helpers ---------------- */
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function getCart() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + path.replace(/^\//, ''), {
      method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS, body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j && (j.description || j.message) || 'Cart error'); e.data = j; throw e; } return j; });
    });
  }
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function kprops(item) {
    var raw = item && item.properties && item.properties.__kaching_bundles;
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw); } catch (e) {}
    try { return JSON.parse(atob(String(raw).trim())); } catch (e) { return null; }   // Kaching base64-encodes the main line
  }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function codeFor(key) { return (CFG.codes && CFG.codes[key] || '').trim(); }

  /* Find the eligible main purchase in a cart. If index is given, only that line counts. */
  function findOffer(cart, index) {
    if (!cart || !cart.items || !cart.items.length) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (index != null && i !== index) continue;
      var it = cart.items[i], k = kprops(it), tier = null, group = null, lines = [];
      if (k) {
        if (!k.main || k.gift || k.upsell) continue;            // gifts + extra-bottle upsell never trigger
        tier = CFG.bundles && CFG.bundles[k.bid];
        if (!tier) continue;                                     // unknown deal bar -> do nothing
        group = k.id;
        lines = cart.items.filter(function (x) { var kk = kprops(x); return kk && kk.id === group; });
      } else if (CFG.mainProductId && String(it.product_id) === String(CFG.mainProductId) && it.quantity === 1 && !hasOtherKaching(cart)) {
        tier = 'buy1'; group = 'line:' + it.key; lines = [it];   // single bottle added without the bundle widget
      } else continue;
      return {
        tier: tier, group: group, bid: k ? k.bid : null,
        main: snapLine(it),
        lines: lines.map(snapLine),
        total: cart.total_price, currency: cart.currency
      };
    }
    return null;
  }
  function hasOtherKaching(cart) { return cart.items.some(function (x) { var k = kprops(x); return k && k.main; }); }
  function snapLine(it) {
    var props = {};
    if (it.properties) Object.keys(it.properties).forEach(function (p) { if (it.properties[p] != null && it.properties[p] !== '') props[p] = it.properties[p]; });
    return {
      variant_id: it.variant_id, quantity: it.quantity, properties: props, key: it.key,
      selling_plan: it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null,
      kaching: kprops(it)
    };
  }
  function groupPresent(cart, group) {
    if (!group) return false;
    if (group.indexOf('line:') === 0) return cart.items.some(function (x) { return String(x.product_id) === String(CFG.mainProductId); });
    return cart.items.some(function (x) { var k = kprops(x); return k && k.main && k.id === group; });
  }

  /* ---------------- cart snapshot (needed BEFORE a removal fires) ---------------- */
  var snapshot = null, busy = false, refreshTimer = null;
  function refreshSnapshot() {
    return getCart().then(function (c) { snapshot = c; reconcile(c); decorateDrawer(c); return c; }).catch(function () { return snapshot; });
  }
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshSnapshot, 120); }

  /* If the rescued bundle leaves the cart, its rescue benefits leave with it. */
  function reconcile(cart) {
    if (busy || !cart || !cart.attributes) return;
    var g = cart.attributes[ATTR.group];
    if (!g || groupPresent(cart, g)) return;
    log('rescued bundle gone, clearing benefits');
    busy = true;
    var attrs = {}; attrs[ATTR.guarantee] = ''; attrs[ATTR.foodmap] = ''; attrs[ATTR.offer] = ''; attrs[ATTR.group] = ''; attrs[ATTR.code] = ''; attrs[ATTR.reason] = '';
    var ourCode = cart.attributes[ATTR.code];
    var p = post('cart/update.js', { attributes: attrs });
    if (ourCode) p = p.then(function () { return removeCode(ourCode); });
    p.catch(function () {}).then(function () { busy = false; return refreshDrawer(false); });
  }

  /* ---------------- discount codes (merchant-created, combine with product discounts) ---------------- */
  function activeCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }
  function setCodes(list) { return post('cart/update.js', { discount: list.join(',') }); }
  function removeCode(code) {
    return getCart().then(function (c) {
      return setCodes(activeCodes(c).filter(function (x) { return x.toUpperCase() !== code.toUpperCase(); }));
    });
  }
  /* Apply and VERIFY: code must be applicable and the total must actually drop by the promised amount. */
  function applyCode(code, amount) {
    return getCart().then(function (before) {
      var keep = activeCodes(before).filter(function (x) { return x.toUpperCase() !== code.toUpperCase(); });
      return setCodes(keep.concat([code])).then(function () { return getCart(); }).then(function (after) {
        var applied = (after.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
        var saved = before.total_price - after.total_price;
        log('code', code, 'applied', applied, 'saved', saved);
        if (applied && saved >= amount - 1) return { ok: true, before: before, after: after, saved: saved };
        return setCodes(keep).then(function () { return getCart(); }).then(function (c) { return { ok: false, before: before, after: c, saved: 0 }; });
      });
    });
  }

  /* ---------------- restore a removed bundle (exact Kaching line properties) ---------------- */
  function lineKey(variant, k) { return variant + '|' + (k ? (k.id + '|' + (k.main ? 'main' : '') + (k.gift || '') + (k.upsell || '')) : ''); }
  function toAddItem(l) {
    var o = { id: l.variant_id, quantity: l.quantity, properties: l.properties };
    if (l.selling_plan) o.selling_plan = l.selling_plan;
    return o;
  }
  function restore(offer) {
    return getCart().then(function (cart) {
      if (groupPresent(cart, offer.group)) return cart;          // already back (never duplicate)
      return post('cart/add.js', { items: [toAddItem(offer.main)] })
        .then(function () { return wait(900); })                 // give Kaching's cart sync a moment
        .then(getCart)
        .then(function (c2) {
          var have = {};
          c2.items.forEach(function (x) { have[lineKey(x.variant_id, kprops(x))] = true; });
          var rest = offer.lines.filter(function (l) { return !(l.kaching && l.kaching.main) && !have[lineKey(l.variant_id, l.kaching)]; });
          // one at a time: an out-of-stock gift must not block the bundle itself
          return rest.reduce(function (p, l) {
            return p.then(function () { return post('cart/add.js', { items: [toAddItem(l)] }).catch(function (e) { log('skip line', l.variant_id, e.message); }); });
          }, Promise.resolve());
        })
        .then(getCart);
    }).then(function (c) {
      if (!groupPresent(c, offer.group) && offer.group.indexOf('line:') !== 0) throw new Error('restore failed');
      return c;
    });
  }

  /* ---------------- drawer refresh (same sections Dawn renders) ---------------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function refreshDrawer(open) {
    var d = drawer();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, sel) { return html ? new DOMParser().parseFromString(html, 'text/html').querySelector(sel) : null; };
        var nd = parse(sections['cart-drawer'], '#CartDrawer'), cur = document.getElementById('CartDrawer');
        if (nd && cur) {
          cur.innerHTML = nd.innerHTML;
          var ov = cur.querySelector('#CartDrawer-Overlay');
          if (ov && d && d.close) ov.addEventListener('click', d.close.bind(d));
        }
        var nb = parse(sections['cart-icon-bubble'], '.shopify-section'), bub = document.getElementById('cart-icon-bubble');
        if (nb && bub) bub.innerHTML = nb.innerHTML;
        return refreshSnapshot();
      })
      .then(function (c) {
        if (d) d.classList.toggle('is-empty', !c || c.item_count === 0);
        if (open && d && d.open && !d.classList.contains('active')) d.open();
        return c;
      })
      .catch(function () {});
  }

  /* Small confirmation inside the drawer so the customer sees what they accepted. */
  function decorateDrawer(cart) {
    var d = drawer(); if (!d) return;
    var host = d.querySelector('.cart-drawer__footer') || d.querySelector('.drawer__footer');
    var old = d.querySelector('.vdr-note');
    var lines = [];
    if (cart && cart.attributes && cart.item_count) {
      if (cart.attributes[ATTR.guarantee]) lines.push(cart.attributes[ATTR.guarantee] + ' added to this order');
      if (cart.attributes[ATTR.foodmap]) lines.push('Free Lower Cortisol Guide added' + (CFG.foodMapNote ? ' — ' + CFG.foodMapNote : ''));
    }
    var sig = lines.join('|');
    if (old && old.getAttribute('data-sig') === sig && old.parentNode === host) return;   // unchanged: don't touch the DOM
    if (old) old.remove();
    if (!host || !lines.length) return;
    var el = document.createElement('div');
    el.className = 'vdr-note';
    el.setAttribute('data-sig', sig);
    el.innerHTML = lines.map(function (t) { return '<p>' + CHECK + '<span>' + esc(t) + '</span></p>'; }).join('');
    host.insertBefore(el, host.firstChild);
  }

  /* ---------------- UI ---------------- */
  var CHECK = '<svg aria-hidden="true" viewBox="0 0 20 20" width="18" height="18"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M5.8 10.3l2.7 2.7 5.7-6" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg aria-hidden="true" viewBox="0 0 20 20" width="16" height="16"><path d="M7.5 4.5L13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BACK = '<svg aria-hidden="true" viewBox="0 0 20 20" width="15" height="15"><path d="M12.5 4.5L7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ui = null, state = null, lastFocus = null;

  function build() {
    if (ui) return ui;
    var wrap = document.createElement('div');
    wrap.className = 'vdr';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="vdr__scrim" data-vdr-dismiss></div>' +
      '<div class="vdr__panel" role="dialog" aria-modal="true" aria-labelledby="vdr-title" aria-describedby="vdr-desc" tabindex="-1">' +
        '<div class="vdr__content" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-vdr-dismiss]')) return dismiss();
      var r = t.closest('[data-vdr-reason]');
      if (r) return chooseReason(r.getAttribute('data-vdr-reason'));
      if (t.closest('[data-vdr-accept]')) return accept();
      if (t.closest('[data-vdr-decline]')) return decline();
      if (t.closest('[data-vdr-back]')) return back();
      if (t.closest('[data-vdr-view]')) { close(); refreshDrawer(true); }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); dismiss(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(wrap.querySelectorAll('button:not([disabled])')).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    ui = { wrap: wrap, panel: wrap.querySelector('.vdr__panel'), content: wrap.querySelector('.vdr__content') };
    return ui;
  }

  function head(title, support) {
    return '<h2 class="vdr__title" id="vdr-title" tabindex="-1">' + esc(title) + '</h2>' +
      (support ? '<p class="vdr__support" id="vdr-desc">' + esc(support) + '</p>' : '');
  }
  function footer(showBack) {
    return '<hr class="vdr__rule">' +
      '<div class="vdr__foot' + (showBack ? '' : ' vdr__foot--single') + '">' +
        (showBack ? '<button type="button" class="vdr__back" data-vdr-back>' + BACK + '<span>Back</span></button>' : '') +
        '<button type="button" class="vdr__decline" data-vdr-decline>Decline Offer</button>' +
      '</div>';
  }

  function askHTML() {
    return head(ASK.title, ASK.support) +
      '<div class="vdr__reasons" role="group" aria-label="' + esc(ASK.support) + '">' +
      REASONS.map(function (r) {
        return '<button type="button" class="vdr__reason" data-vdr-reason="' + r.id + '"><span>' + esc(r.label) + '</span>' + CHEV + '</button>';
      }).join('') +
      '</div>';
  }

  function offerHTML() {
    var o = OFFERS[state.offer.tier], s = o[state.stage], c = s.card, cur = state.offer.currency, html = '';
    html += head(pick(s.title, state.reason), pick(s.support, state.reason));
    html += '<div class="vdr__card">';
    if (c.title) html += '<p class="vdr__card-title">' + esc(c.title) + '</p>';
    if (c.sub) html += '<p class="vdr__card-sub">' + esc(c.sub) + '</p>';
    if (c.price && state.preview) {
      html += '<p class="vdr__price"><s>' + money(state.preview.before, cur) + '</s> <strong>' + money(state.preview.after, cur) + '</strong></p>' +
              '<p class="vdr__card-sub">New order total · shipping and taxes at checkout</p>';
    }
    if (c.list) html += '<ul class="vdr__list">' + c.list.map(function (t) { return '<li>' + CHECK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul>';
    if (c.note) html += '<p class="vdr__card-sub">' + esc(c.note) + '</p>';
    if (state.mode === 'remove') html += '<p class="vdr__card-sub vdr__card-sub--restore">Puts your ' + esc(o.label) + ' back in your cart.</p>';
    html += '<button type="button" class="vdr__cta" data-vdr-accept>' + esc(s.cta) + '</button>';
    html += '</div>';
    return html + footer(true);
  }

  function doneHTML(give, r) {
    var cur = (r.after && r.after.currency) || state.offer.currency, items = [];
    if (give.foodmap) items.push('Lower Cortisol Guide — FREE');
    if (give.days) items.push(give.days + '-Day Money-Back Guarantee');
    if (give.off && r.codeOk) items.push(money(r.before.total_price - r.after.total_price, cur) + ' off · new total ' + money(r.after.total_price, cur));
    var html = head(r.restored ? 'Your order is back.' : "You're all set.",
      give.foodmap && CFG.foodMapNote ? 'Your guide is ' + CFG.foodMapNote + '.' : 'Everything below is saved to your order.');
    html += '<div class="vdr__card"><ul class="vdr__list">' + items.map(function (t) { return '<li>' + CHECK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul>';
    if (give.off && !r.codeOk) html += '<p class="vdr__warn">We couldn’t apply the extra ' + money(give.off, cur) + ' to this cart, so your total is unchanged.</p>';
    html += '<button type="button" class="vdr__cta" data-vdr-view>' + 'VIEW MY CART' + '</button></div>';
    return html;
  }

  function failHTML() {
    return head('That didn’t go through.', 'Nothing was changed. You can add your bundle again from the product page.') +
      '<div class="vdr__card"><button type="button" class="vdr__cta" data-vdr-dismiss>CLOSE</button></div>';
  }

  function render(html, focusSel) {
    var c = ui.content;
    c.classList.remove('is-in');
    c.innerHTML = html;
    void c.offsetWidth;
    c.classList.add('is-in');
    ui.panel.scrollTop = 0;
    var f = focusSel && ui.panel.querySelector(focusSel);
    (f || ui.panel).focus({ preventScroll: true });
  }
  function show() {
    if (state.screen === 'ask') render(askHTML(), '.vdr__title');
    else render(offerHTML(), '.vdr__title');
  }

  function open(offer, mode) {
    if (session.get()) return;
    if (ui && !ui.wrap.hidden) return;
    if (!OFFERS[offer.tier]) return;
    session.set('shown');
    build();
    lastFocus = document.activeElement;
    state = { offer: offer, mode: mode, screen: 'ask', stage: 's1', reason: null, preview: null };
    ui.wrap.hidden = false;
    document.documentElement.classList.add('vdr-lock');
    void ui.wrap.offsetWidth;
    setTimeout(function () { if (state) ui.wrap.classList.add('is-open'); }, 16);
    show();
    log('open', offer.tier, mode, offer);
  }

  function close() {
    if (!ui || ui.wrap.hidden) return;
    ui.wrap.classList.remove('is-open');
    document.documentElement.classList.remove('vdr-lock');
    var w = ui.wrap;
    setTimeout(function () { w.hidden = true; }, 220);
    var b = lastFocus && document.contains(lastFocus) && lastFocus.offsetParent !== null ? lastFocus : document.getElementById('cart-icon-bubble');
    if (b && b.focus) b.focus({ preventScroll: true });
    state = null;
  }
  function dismiss() { if (state && !state.working) { session.set('done'); close(); } }

  function chooseReason(id) {
    if (!state || state.working) return;
    state.reason = id;
    state.screen = 'offer';
    state.stage = 's1';
    show();
  }

  function back() {
    if (!state || state.working) return;
    if (state.stage === 's2') state.stage = 's1';
    else state.screen = 'ask';
    show();
  }

  function setWorking(on, which) {
    state.working = on;
    [].forEach.call(ui.content.querySelectorAll('button'), function (b) { b.disabled = on; });
    var b = which && ui.content.querySelector(which);
    if (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); b.classList.toggle('is-loading', on); }
  }

  /* Before showing a $10 / $15 screen, quietly check the code really applies to THIS cart
     (code applicable + total drops by the amount), then put the cart back exactly as it was. */
  var probeCache = {};
  function probeCode(code, amount) {
    if (probeCache[code] && probeCache[code].ok === false) return Promise.resolve(probeCache[code]);
    busy = true;
    return getCart().then(function (before) {
      var keep = activeCodes(before).filter(function (x) { return x.toUpperCase() !== code.toUpperCase(); });
      return setCodes(keep.concat([code])).then(getCart).then(function (after) {
        var applicable = (after.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
        var res = { ok: applicable && before.total_price - after.total_price >= amount - 1, before: before.total_price, after: after.total_price };
        return setCodes(keep).then(function () { return res; });
      });
    }).then(function (res) { busy = false; probeCache[code] = res; log('probe', code, res); return res; },
            function () { busy = false; return { ok: false }; });
  }

  function decline() {
    if (!state || state.working) return;
    if (state.screen === 'ask' || state.stage === 's2') { session.set('done'); close(); return; }
    var s2 = OFFERS[state.offer.tier].s2;
    if (!s2.give.off) { state.stage = 's2'; show(); return; }
    var code = codeFor(s2.give.codeKey);
    if (!code) { session.set('done'); close(); return; }          // no code set -> never advertise money off
    if (state.mode === 'remove') {
      // the bundle is out of the cart, so the code can't be tested on it now; use an earlier test if there is one
      var known = probeCache[code];
      if (known && known.ok === false) { session.set('done'); close(); return; }
      state.preview = { before: state.offer.total, after: Math.max(0, state.offer.total - s2.give.off) };
      state.stage = 's2'; show(); return;
    }
    setWorking(true, '[data-vdr-decline]');
    probeCode(code, s2.give.off).then(function (r) {
      if (!state) return;
      setWorking(false);
      if (!r.ok) { session.set('done'); close(); return; }
      state.preview = { before: r.before, after: r.after };
      state.stage = 's2'; show();
    });
  }

  function accept() {
    if (!state || state.working) return;
    var offer = state.offer, o = OFFERS[offer.tier], s = o[state.stage], give = s.give;
    setWorking(true, '[data-vdr-accept]');
    busy = true;
    var result = { restored: false, code: null, codeOk: true, before: null, after: null };
    var chain = Promise.resolve();
    if (state.mode === 'remove') chain = chain.then(function () { return restore(offer).then(function () { result.restored = true; }); });
    chain = chain.then(function () {
      var attrs = {};
      attrs[ATTR.offer] = o.label + ' — rescue ' + (state.stage === 's1' ? 'stage 1' : 'stage 2') + ' accepted';
      attrs[ATTR.group] = offer.group;
      var rs = REASONS.filter(function (x) { return x.id === state.reason; })[0];
      if (rs) attrs[ATTR.reason] = rs.label;
      if (give.days) attrs[ATTR.guarantee] = give.days + '-Day Money-Back Guarantee';
      if (give.foodmap) attrs[ATTR.foodmap] = 'Yes — free digital Lower Cortisol Guide';
      return post('cart/update.js', { attributes: attrs });
    });
    if (give.off) {
      chain = chain.then(function () {
        var code = codeFor(give.codeKey);
        return applyCode(code, give.off).then(function (r) {
          result.code = code; result.codeOk = r.ok; result.before = r.before; result.after = r.after;
          if (r.ok) { var a = {}; a[ATTR.code] = code; return post('cart/update.js', { attributes: a }); }
        });
      });
    }
    chain.then(function () {
      busy = false;
      session.set('done');
      if (state.mode === 'remove' && result.codeOk) {
        state.working = false;
        close();
        return refreshDrawer(true);
      }
      return refreshDrawer(false).then(function () { state.working = false; render(doneHTML(give, result), '.vdr__cta'); });
    }).catch(function (e) {
      busy = false;
      session.set('done');
      log('accept failed', e);
      state.working = false;
      render(failHTML(), '.vdr__cta');
      refreshDrawer(false);
    });
  }
  /* ---------------- triggers (one delegated set of listeners) ---------------- */
  function drawerIsOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }

  /* Calm timing: the offer never interrupts. It waits until the shopper closes the cart herself,
     then appears after DELAY ms, and only if she's still on the page with the cart closed. */
  var DELAY = (CFG.delayMs != null ? +CFG.delayMs : 2500);
  var pendingRemoved = null, closeTimer = null, leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; clearTimeout(closeTimer); });
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href], [name="checkout"], button[type="submit"]');
    if (a && !a.closest('.vdr') && !a.closest('cart-drawer .drawer__close')) {
      var href = a.getAttribute && a.getAttribute('href') || '';
      if (a.name === 'checkout' || /checkout/.test(href) || (href && href.charAt(0) !== '#')) clearTimeout(closeTimer);
    }
  }, true);

  function onUserClose() {
    if (session.get() || busy) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (leaving || drawerIsOpen() || session.get() || busy) return;   // she reopened the cart or is leaving
      if (ui && !ui.wrap.hidden) return;
      getCart().then(function (cart) {
        if (leaving || drawerIsOpen()) return;
        snapshot = cart;
        // she removed a bundle earlier and hasn't put it back -> offer to restore it
        if (pendingRemoved && !groupPresent(cart, pendingRemoved.group)) {
          var removed = pendingRemoved; pendingRemoved = null;
          return open(removed, 'remove');
        }
        pendingRemoved = null;
        var offer = findOffer(cart);
        // already accepted for this bundle -> nothing more to offer
        if (offer && cart.attributes && cart.attributes[ATTR.group] === offer.group) return;
        if (offer) open(offer, 'close');
      }).catch(function () {});
    }, DELAY);
  }

  /* Tested on the live store: when the main bundle line is removed, Kaching leaves that bundle's
     gifts at full price and the extra-bottle upsell at full price in the cart.
     Remove those orphaned lines so the shopper's removal is actually complete. */
  function removeOrphanGifts(cart, group) {
    var orphans = cart.items.filter(function (x) { var k = kprops(x); return k && !k.main && (k.gift || k.upsell) && k.id === group; });
    if (!orphans.length) return Promise.resolve(cart);
    var updates = {};
    orphans.forEach(function (x) { updates[x.key] = 0; });
    return post('cart/update.js', { updates: updates }).then(function () { return refreshDrawer(false); }).catch(function () { return cart; });
  }

  function onRemove(btn) {
    if (busy) return;
    var idx = parseInt(btn.getAttribute('data-index') || btn.dataset.index, 10) - 1;
    var snap = snapshot;
    if (isNaN(idx) || !snap || !snap.items[idx]) return;
    // safety: the row the shopper clicked must be the line we think it is
    var row = document.getElementById('Drawer-quantity-' + (idx + 1)) || document.getElementById('Quantity-' + (idx + 1));
    var vid = row && (row.getAttribute('data-quantity-variant-id') || '');
    if (vid && String(vid) !== String(snap.items[idx].variant_id)) { log('row mismatch, skipping'); return; }
    var offer = findOffer(snap, idx);
    if (!offer) return;                                      // upsell, gift or unrelated product
    log('main bundle removed', offer);
    // let Dawn finish the removal, then confirm the bundle is really gone
    var tries = 0;
    (function check() {
      tries++;
      getCart().then(function (c) {
        snapshot = c;
        if (!groupPresent(c, offer.group) || (offer.group.indexOf('line:') === 0 && !c.items.some(function (x) { return x.key === offer.main.key; }))) {
          removeOrphanGifts(c, offer.group).then(function () {
            if (session.get()) return;
            // never interrupt: remember the removed bundle and offer it back once she closes the cart
            pendingRemoved = offer;
            if (!drawerIsOpen() && !document.querySelector('cart-drawer')) {
              // full cart page (no drawer): wait, then offer
              clearTimeout(closeTimer);
              closeTimer = setTimeout(function () {
                if (leaving || !pendingRemoved) return;
                getCart().then(function (c2) { if (pendingRemoved && !groupPresent(c2, pendingRemoved.group)) { var r = pendingRemoved; pendingRemoved = null; open(r, 'remove'); } });
              }, DELAY);
            }
          });
        } else if (tries < 10) setTimeout(check, 350);
      }).catch(function () {});
    })();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('cart-drawer .drawer__close') || t.closest('#CartDrawer-Overlay')) return onUserClose();
    var rm = t.closest('cart-remove-button');
    if (rm && (rm.closest('cart-drawer') || rm.closest('cart-items'))) return onRemove(rm);
  }, true);

  document.addEventListener('keyup', function (e) {
    if ((e.key === 'Escape' || e.code === 'Escape') && e.target && e.target.closest && e.target.closest('cart-drawer')) onUserClose();
  }, true);

  /* keep the snapshot fresh: drawer open/re-render, Dawn cart events */
  function watchDrawer() {
    var d = drawer();
    if (!d || d.__vdrWatched) return;
    d.__vdrWatched = true;
    var ours = function (n) { return n.nodeType !== 1 || (n.classList && n.classList.contains('vdr-note')) || (n.closest && n.closest('.vdr-note')); };
    new MutationObserver(function (m) {
      var relevant = false;
      for (var i = 0; i < m.length; i++) {
        var r = m[i];
        if (r.type === 'attributes') { if (r.target === d && d.classList.contains('active')) relevant = true; continue; }
        if (ours(r.target)) continue;
        var nodes = [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes));
        if (nodes.some(function (n) { return !ours(n); })) relevant = true;
      }
      if (relevant) { decorateDrawer(snapshot); scheduleRefresh(); }
    }).observe(d, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
  function init() {
    // pubsub.js loads with defer, so subscribe once the DOM is ready
    // Dawn declares PUB_SUB_EVENTS with const, so it is NOT a window property: check it directly
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== 'vyrael-rescue') scheduleRefresh(); });
      }
    } catch (e) {}
    // Kaching adds bundles with its own request, so also refresh whenever any cart request finishes
    try {
      if (window.PerformanceObserver) {
        new PerformanceObserver(function (list) {
          if (list.getEntries().some(function (en) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(en.name); }) && !busy) scheduleRefresh();
        }).observe({ type: 'resource', buffered: false });
      }
    } catch (e) {}
    watchDrawer(); refreshSnapshot();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.VyraelRescue = {
    _cfg: CFG, _find: findOffer,
    reset: function () { session.set(''); },
    refresh: function () { return refreshSnapshot(); },
    // for testing from the browser console: VyraelRescue.open()
    open: function (mode) { return getCart().then(function (c) { var o = findOffer(c); if (o) open(o, mode || 'close'); return !!o; }); }
  };
})();
